var render = function render(){var _vm=this,_c=_vm._self._c;return _c('g',[_c('rect',_vm._b({},'rect',{ 
            class : 'tool_svgElem',
            id     : _vm.tool.id + '-body',
            x      : Math.min(_vm.tool.coords.pts[0].x, _vm.tool.coords.pts[1].x), 
            y      : Math.min(_vm.tool.coords.pts[0].y, _vm.tool.coords.pts[1].y),
            width  : Math.abs(_vm.tool.coords.pts[1].x - _vm.tool.coords.pts[0].x),
            height : Math.abs(_vm.tool.coords.pts[1].y - _vm.tool.coords.pts[0].y),
            fill   : _vm.fill,
            fillOpacity : 0.2,          
        },false))])
}
var staticRenderFns = []

export { render, staticRenderFns }